export default __webpack_public_path__ + "static/media/star-icon.f3694d35.svg";